import React, { useState } from "react";
import Text from "@/components/ui/text";
import Modal from "@/components/controls/Modal";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import TextareaAutosize from "react-textarea-autosize";
import { isEmpty } from "lodash";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit: (reason: string) => void;
  tKey: string;
}

const MarkAsStuckModal: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  handleSubmit,
  tKey
}) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");

  return (
    <Modal
      open={isOpen}
      setIsOpen={setIsOpen}
      contentClassname="w-[35rem]"
      data-test="mark-as-stuck-modal"
      title={
        <Text
          as="div"
          variant="lgSubtitleH1"
          data-test="mark-as-stuck-modal-title"
        >
          {t(`${tKey}.markAsStuck`)}
        </Text>
      }
      content={
        <div
          className="h-fit w-[35rem] p-4 flex flex-col gap-2"
          data-test="mark-as-stuck-modal-content"
        >
          <div className="flex">
            <Text variant="labelSecondary">{t("leads.modal.reason")}</Text>
            <span className="text-primary ml-1">*</span>
          </div>
          <TextareaAutosize
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            minRows={4}
            className="w-full text-base text-primary placeholder:text-tertiary px-3 py-[6px] bg-surface-field-default border-[0.5px] border-border-field-default rounded-lg resize-none shadow-field transition-all duration-200 ease-in-out hover:border-border-field-hover focus:outline-none focus:border-border-field-focus focus:bg-surface-focus-selected focus:shadow-field-focus"
            data-test="mark-as-stuck-modal-reason-input"
          />
        </div>
      }
      footer={
        <div
          className="flex justify-end gap-2"
          data-test="mark-as-stuck-modal-footer"
        >
          <Button
            data-test="mark-as-stuck-modal-cancel-button"
            variant="secondary"
            onClick={() => setIsOpen(false)}
          >
            {t("cancel")}
          </Button>
          <Button
            data-test="mark-as-stuck-modal-submit-button"
            destructive
            onClick={() => handleSubmit(reason)}
            disabled={isEmpty(reason)}
          >
            {t(`${tKey}.submitMarkAsStuck`)}
          </Button>
        </div>
      }
    />
  );
};

export default MarkAsStuckModal;
